export const Primary = {
  main: "#009999",
  light: "#E9FBFB",
  dark: "#005755",
  contrastText: "#fff",
};

export const Secondary = {
  main: "#731F99",
  light: "#F0DDF8",
  dark: "#481360",
  contrastText: "#fff",
};

export const AppBarBackground = {
  main: "#fff",
};
